import { useState, useRef } from 'react';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { useTranslation } from 'react-i18next';

// Components
import CircularProgress from '@mui/material/CircularProgress';
import ImageZoom from '../ImageZoom';

// Queries
import postGlobal from '../Queries/postGlobal';

// Styles
import styles from './index.module.sass';

// Images
import PRELOAD from '../../images/preload.jpg';

const date = new Date();

export default function Product({
  product,
  orderDetail,
  catSelected,
  screenSize,
  webservice,
  getCookie,
  addedArray,
  setAddedArray,
  setOrderData,
  setSessionMessage,
  device,
  history,
  promocionEncontrada,
  arte,
}) {
  const [productQuantity, setProductQuantity] = useState(1);
  const [productSelected, setProductSelected] = useState(product[0] || {});
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation('products');

  const {
    clave = '',
    descri = '',
    precio = '',
    status = '',
    precioLista = '',
    agotado,
    txtPromo,
    hastaAgotarExistencias = false,
    // fichaTecnica = false,
  } = productSelected || {};

  const isPromo = parseFloat(precio) < parseFloat(precioLista) ? true : false;

  const sliderRef = useRef();

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    beforeChange: (oldIndex, newIndex) => beforeChange(oldIndex, newIndex),
  };

  function next() {
    sliderRef.current.slickNext();
  }

  function previous() {
    sliderRef.current.slickPrev();
  }

  function handleChange(e) {
    const value = e.target.value;
    setProductQuantity(value);
  }

  function beforeChange(oldIndex, newIndex) {
    setProductSelected(product[newIndex]);
  }

  async function addToCart(productId, productQuantity, productName, productPrice) {
    setLoading(true);
    const order = await postGlobal({
      tmbservice: 'getAgregarAlCarrito',
      jsonBody: {
        accion: 'ORDENAR',
        usuarioOK: getCookie('usuarioOk'),
        folioPedido: getCookie('folioPedido'),
        almacen: getCookie('warehouse'),
        categoria: catSelected,
        caller: 'consultarCart',
        clave: productId,
        cantidad: productQuantity,
        numeroLinea: '',
        textoProdSeleccion: '',
        idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
        origen: 'CARRITONUE',
      },
    });

    const { tipoMensaje = 'error', mensaje = '' } = order;

    setSessionMessage(mensaje);

    if (tipoMensaje === 'exito') {
      setAddedArray((oldArray) => {
        return [...oldArray, productId];
      });
      setOrderData(order);
    }

    setLoading(false);
  }

  function onChangeQuantity(action) {
    if (action === 'add') setProductQuantity(parseInt(productQuantity) + 1);
    else {
      if (parseInt(productQuantity) <= 1) setProductQuantity(0);
      else setProductQuantity(parseInt(productQuantity) - 1);
    }
  }

  console.log(promocionEncontrada, 'promo locailizada0', arte);

  return (
    <div className={`${styles.product} ${styles[screenSize]}`}>
      <div className={styles.container}>
        <div className={styles.content}>
          {promocionEncontrada === true && (
            <div className={styles.imagenPequeñaPromo}>
              <img src={arte} alt='imagenPequeñaPromo' className={styles.imgPequeñaPromo} />
              &nbsp;
            </div>
          )}

          {product && product.length > 1 && (
            <div className={`${styles.arrow} ${styles.arrowLeft}`} onClick={previous}>
              <i className={`material-icons `}>navigate_before</i>
            </div>
          )}
          {product && product.length > 1 && (
            <div className={`${styles.arrow} ${styles.arrowRight}`} onClick={next}>
              <i className={`material-icons `}>navigate_next</i>
            </div>
          )}
          <div
            className={styles.productImage}
            style={{
              background: `transparent url(${PRELOAD}) center no-repeat`,
            }}>
            {/* {fichaTecnica && (
              <div className={styles.seePDP}>
                <i
                  className={`material-icons-outlined`}
                  onClick={() => {
                    history.push(`/cart/productdetail/${clave}`);
                  }}>
                  visibility
                </i>
              </div>
            )} */}
            <Slider {...settings} className={styles.slider} ref={sliderRef}>
              {product.map((val, key) => {
                return (
                  <ImageZoom
                    key={key}
                    device={device}
                    imgsrc={
                      val?.imagenAlt
                        ? `${val?.imagenAlt}?x=${date.getFullYear()}${date.getMonth() + 1}`
                        : ''
                    }
                    idComplement={val?.clave || ''}
                  />
                );
              })}
            </Slider>
          </div>
          <div className={styles.code}>
            {t('keyPlaceholder')}: {clave || ''}
          </div>
          <div className={styles.productName}>{descri || ''}</div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.price}>
            {isPromo && <div className={styles.priceList}>${precioLista}</div>}${precio || ''}
          </div>
          {txtPromo && <div className={styles.txtPromo}>{txtPromo}</div>}
          {(agotado && (
            <div className={styles.outOfStock}>
              {hastaAgotarExistencias ? t('soldOut') : t('temporarilyOutOfStock')}
            </div>
          )) || (
            <div className={styles.actions}>
              <div className={`${styles.row} ${styles.quantity}`}>
                <i
                  className={`material-icons ${styles.quantityIcon}`}
                  onClick={() => onChangeQuantity('subtract')}>
                  remove
                </i>
                <input
                  type='text'
                  className={styles.quantityInput}
                  value={productQuantity || ''}
                  onChange={handleChange}
                />
                <i
                  className={`material-icons ${styles.quantityIcon}`}
                  onClick={() => onChangeQuantity('add')}>
                  add
                </i>
              </div>
              <div
                className={`${styles.row} ${styles.addToCart}`}
                onClick={() => {
                  if (!loading) {
                    addToCart(
                      productSelected?.clave || '',
                      productQuantity,
                      descri || '',
                      precio || '',
                    );
                  }
                }}>
                {(loading && <CircularProgress className={styles.circularProgress} />) || (
                  <>
                    <i className={`material-icons-outlined ${styles.bagIcon}`}>shopping_bag</i>
                    <span className={styles.buttonText}>{t('addToCart')}</span>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
